// Module
var code = "<div class=\"js-link-label {{.subclass}}\" style=\"{{>visibility}}\" {{^.enabled}}disabled=\"\" {{/}} on-click=\"linkClick\">\r\n    <a {{#.linkHref}}href=\"{{.linkHref}}\" {{/}} target=\"_blank\" rel=\"noopener noreferrer\" as-tooltip=\"tooltip\">{{.text}}</a>\r\n</div>";
// Exports
export default code;